<template>
	<app>
		<crumb-bar></crumb-bar>
		<module>
			<flow-node :node="nodeList" :current="datum ? 2 : 1"></flow-node>
			
			<div class="detail-info flex-between">
				<div>
					<img :src="insuranceCompany.image" class="logo">
					<p>金融机构联系人：{{insuranceCompany.contacts}}</p>
					<p>金融机构电话：{{insuranceCompany.mobile}}</p>
				</div>
				<div v-if="!datum">
					<p class="flex">
						<label>企业名称：</label>
						<span class="flex-grow-auto">{{userInfo.name}}</span>
					</p>
					<p class="flex">
						<label>营业执照号：</label>
						<span class="flex-grow-auto">{{userInfo.yyzzh}}</span>
					</p>
					<p class="flex">
						<label>法人：</label>
						<span class="flex-grow-auto">{{userInfo.user_realname}}</span>
					</p>
					<p class="flex">
						<label>最高资质：</label>
						<span class="flex-grow-auto">{{userInfo.qyzz}}</span>
					</p>
					<p class="flex">
						<label>详细地址：</label>
						<span class="flex-grow-auto">{{userInfo.province_name}}{{userInfo.city_name}}{{userInfo.county_name}}{{userInfo.address}}</span>
					</p>
				</div>
				<div v-else>
					<p class="flex">
						<label>项目名称：</label>
						<span class="flex-grow-auto">{{insuranceDetail.project_name}}</span>
					</p>
					<p class="flex">
						<label>企业名称：</label>
						<span class="flex-grow-auto">{{insuranceDetail.zbqy_name}}</span>
					</p>
					<p class="flex">
						<label>保函类型：</label>
						<span class="flex-grow-auto">{{insuranceDetail.bx_type_name}}</span>
					</p>
					<p class="flex">
						<label>保单金额：</label>
						<span class="flex-grow-auto">￥{{insuranceDetail.bd_money}}</span>
					</p>
					<p class="flex">
						<label>保费金额：</label>
						<span class="flex-grow-auto">￥{{insuranceDetail.bf_money}}</span>
					</p>
				</div>
			</div>
			
			<c-form v-if="!datum" ref="form">
				<c-title>基本信息</c-title>
				<c-form item-width="50%">
					<c-form-item type="hidden" name="bx_id"></c-form-item>
					<c-form-item type="hidden" name="bxgs_id"></c-form-item>
					<c-form-item v-model="currentProjectId" type="select" label="项目名称" name="project_id" :options="projectList" width="100%" required :disabled="!!id" :inline-word="false">
						<p slot="word">未找到项目？<router-link to="/transact/bidding/create" class="s-link">前往创建</router-link></p>
					</c-form-item>
					<c-form-item type="input" label="所属行业" name="sshy" disabled></c-form-item>
					<c-form-item v-model="currentInsuranceId" type="select" label="保函类型" name="bx_type_id" :options="insuranceType" required></c-form-item>
					<c-form-item type="input" label="工程造价" name="zb_money" disabled input-word="元" decimal="2"></c-form-item>
					<c-form-item type="input" label="建设地址" name="xm_address" disabled></c-form-item>
					<c-form-item type="input" label="工期" name="sggq" disabled input-word="天"></c-form-item>
					<c-form-item v-model="currentTerm" type="select" label="保险期限" name="bxqx" :options="termList" required></c-form-item>
					<c-form-item v-model="insuranceSum" type="number" label="保单金额" name="bd_money" required input-word="元" decimal="2" :limit="[1,99999999]" :inline-word="false">
						<p slot="word">根据招标文件规定的比例填写金额</p>
					</c-form-item>
					<c-form-item type="number" label="保费金额" name="bf_money" :value="premium" required input-word="元" decimal="2" :limit="[1,99999999]" :inline-word="false">
						<p slot="word">{{premiumTips}}，<font color="red">特殊情况请与保险公司沟通后自行填写</font></p>
					</c-form-item>
					<c-form-item type="input" label="授权人" name="sqr_name" required></c-form-item>
					<c-form-item type="input" label="项目联系人" name="yzdw_lxr"></c-form-item>
					<c-form-item type="input" label="授权人电话" name="sqr_lxdh" required></c-form-item>
					<c-form-item type="input" label="项目联系电话" name="yzdw_lxdh"></c-form-item>
				</c-form>
				
				<c-title>被保险人信息</c-title>
				<c-form item-width="50%">
					<c-form-item type="input" label="被保险人" name="bbxr_name" disabled></c-form-item>
					<c-form-item type="input" label="被保险人组织代码" name="bbxr_jgdm" disabled></c-form-item>
					<c-form-item type="input" label="担保人姓名" name="dbr_name"></c-form-item>
				</c-form>
				
				<c-title>业主单位信息</c-title>
				<c-form item-width="50%">
					<c-form-item type="input" label="业主单位名称" name="yzdw_name" disabled></c-form-item>
					<c-form-item type="input" label="业主单位地址" name="yzdw_address" disabled></c-form-item>
					<c-button slot="button" size="m" width="300" @click="submit">下一步</c-button>
				</c-form>
			</c-form>
			
			<div v-else>
				<c-title>其它资料上传</c-title>
				<c-detail>
					<c-detail-item label="营业执照" required full>
						<c-upload-file v-model="datumDetail.yyzz_path" media="image" type="image"></c-upload-file>
					</c-detail-item>
					<c-detail-item label="法人身份证头像面" required full>
						<c-upload-file v-model="datumDetail.frsfztx_path" media="image" type="image"></c-upload-file>
					</c-detail-item>
					<c-detail-item label="法人身份证国徽面" required full>
						<c-upload-file v-model="datumDetail.frsfzgh_path" media="image" type="image"></c-upload-file>
					</c-detail-item>
					<c-detail-item label="资质证书" required full>
						<c-upload-file v-model="datumDetail.zzzs_path" media="image" type="image"></c-upload-file>
					</c-detail-item>
					<c-detail-item label="招标文件" full>
						<c-file :src="projectInfo.files_path"></c-file>
					</c-detail-item>
					<c-detail-item label="中标通知书" full>
						<c-file :src="projectInfo.zb_path"></c-file>
					</c-detail-item>
					<c-detail-item v-if="insuranceDetail.bx_type_id == 2" label="竣工验收报告" required full>
						<c-upload-file v-model="datumDetail.jgysbg_path" type="word,excel,pdf,zip"></c-upload-file>
					</c-detail-item>
					<c-detail-item label="反担保承诺书" required full>
						<c-radio-group v-if="templateDetail.fdb_file_path" v-model="datumDetail.qs_fdb_type" style="margin-bottom: 6px;">
							<c-radio v-for="(item, i) in fileTypeOption" :key="i" :value="item.value">{{item.name}}</c-radio>
						</c-radio-group>
						<div v-show="datumDetail.qs_fdb_type == 1">
							<c-upload-file v-model="datumDetail.fdb_path" type="word,excel,pdf,zip" button="上传盖章文件">
								<span slot="word">
									<span style="margin-right: 10px; color: #f55;">每页都需要加盖公章</span>
									<a v-if="templateDetail.fdb_file_path" class="s-link" @click="downloadTemplet(2)">下载模板</a>
								</span>
							</c-upload-file>
						</div>
						<div v-show="datumDetail.qs_fdb_type == 2">
							<c-upload-file v-model="datumDetail.fdb_path" icon="signet" button="在线盖章文件" custom @click="signHandle(3)">
								<span slot="word" style="margin-right: 10px; color: #f55;">每页都需要加盖公章</span>
							</c-upload-file>
						</div>
					</c-detail-item>
					<c-detail-item label="投保单" required full>
						<c-radio-group v-if="templateDetail.tbd_file_path" v-model="datumDetail.qs_tbd_type" style="margin-bottom: 6px;">
							<c-radio v-for="(item, i) in fileTypeOption" :key="i" :value="item.value">{{item.name}}</c-radio>
						</c-radio-group>
						<div v-show="datumDetail.qs_tbd_type == 1">
							<c-upload-file v-model="datumDetail.tbd_path" type="word,excel,pdf,zip" button="上传盖章文件">
								<span slot="word">
									<span style="margin-right: 10px; color: #f55;">每页都需要加盖公章</span>
									<a v-if="templateDetail.tbd_file_path" class="s-link" @click="downloadTemplet(1)">下载模板</a>
								</span>
							</c-upload-file>
						</div>
						<div v-show="datumDetail.qs_tbd_type == 2">
							<c-upload-file v-model="datumDetail.tbd_path" icon="signet" button="在线盖章文件" custom @click="signHandle(4)">
								<span slot="word" style="margin-right: 10px; color: #f55;">每页都需要加盖公章</span>
							</c-upload-file>
						</div>
					</c-detail-item>
					<c-detail-item v-if="insuranceCompany.id == 6" label="业务申请书" required full>
						<c-radio-group v-if="templateDetail.ywsqs_file_path" v-model="datumDetail.qs_ywsqs_type" style="margin-bottom: 6px;">
							<c-radio v-for="(item, i) in fileTypeOption" :key="i" :value="item.value">{{item.name}}</c-radio>
						</c-radio-group>
						<div v-show="datumDetail.qs_ywsqs_type == 1">
							<c-upload-file v-model="datumDetail.ywsqs_path" type="word,excel,pdf,zip" button="上传盖章文件">
								<span slot="word">
									<span style="margin-right: 10px; color: #f55;">每页都需要加盖公章</span>
									<a v-if="templateDetail.ywsqs_file_path" class="s-link" @click="downloadTemplet(4)">下载模板</a>
								</span>
							</c-upload-file>
						</div>
						<div v-show="datumDetail.qs_ywsqs_type == 2">
							<c-upload-file v-model="datumDetail.ywsqs_path" icon="signet" button="在线盖章文件" custom @click="signHandle(5)">
								<span slot="word" style="margin-right: 10px; color: #f55;">每页都需要加盖公章</span>
							</c-upload-file>
						</div>
					</c-detail-item>
					<c-detail-item v-if="insuranceCompany.id == 6" label="征信授权书" required full>
						<c-radio-group v-if="templateDetail.zxsqs_file_path" v-model="datumDetail.qs_zxsqs_type" style="margin-bottom: 6px;">
							<c-radio v-for="(item, i) in fileTypeOption" :key="i" :value="item.value">{{item.name}}</c-radio>
						</c-radio-group>
						<div v-show="datumDetail.qs_zxsqs_type == 1">
							<c-upload-file v-model="datumDetail.zxsqs_path" type="word,excel,pdf,zip" button="上传盖章文件">
								<span slot="word">
									<span style="margin-right: 10px; color: #f55;">每页都需要加盖公章</span>
									<a v-if="templateDetail.zxsqs_file_path" class="s-link" @click="downloadTemplet(5)">下载模板</a>
								</span>
							</c-upload-file>
						</div>
						<div v-show="datumDetail.qs_zxsqs_type == 2">
							<c-upload-file v-model="datumDetail.zxsqs_path" icon="signet" button="在线盖章文件" custom @click="signHandle(6)">
								<span slot="word" style="margin-right: 10px; color: #f55;">每页都需要加盖公章</span>
							</c-upload-file>
						</div>
					</c-detail-item>
					<c-detail-item label="施工合同附件" full>
						<c-upload-file v-model="datumDetail.sght_path" word="可使用会议纪要代替" type="word,excel,pdf,zip"></c-upload-file>
					</c-detail-item>
					<c-detail-item label="财务报表" required full>
						<c-upload-file v-model="datumDetail.cwbb_path" word="近3个月至半年投保企业财务报表" type="word,excel,pdf,zip"></c-upload-file>
					</c-detail-item>
					<c-button slot="button" color="yellow" size="m" width="300" @click="submit">提交申报</c-button>
				</c-detail>
			</div>
		</module>
		
		<c-dialog ref="agreement" title="责任告知" width="1000" height="750" button-name="我已阅读并同意" cancel-button-name="不同意" :close-button="false" @resolve="initApply" @cancel="navigateTo('/transact/insurance')">
			<div class="agreement" v-html="agreementContent"></div>
		</c-dialog>
	</app>
</template>

<script>
	import flowNode from '@/components/module/flow_node.vue'
	import {mapState, mapGetters} from 'vuex'
	import agreementContent from './insurance_agreement.js'
	import validate from '@/assets/script/validate.js'
	
	export default {
		components: {
			flowNode
		},
		
		props: {
			datum: Boolean,
			id: String,
			type: String,
			companyId: String,
			projectId: String
		},
		
		data() {
			return {
				agreementContent,
				nodeList: [{
					name: '填写基本信息'
				}, {
					name: '上传企业材料'
				}, {
					name: '提交成功'
				}],
				currentNode: 1,
				
				insuranceCompany: {},
				insuranceDetail: {},
				templateDetail: {},
				
				projectList: [],
				currentProjectId: '',
				
				insuranceType: [],
				currentInsuranceId: '',
				
				termList: [],
				currentTerm: '',
				insuranceSum: '',
				
				projectInfo: {},
				datumDetail: {},
				fileTypeOption: [{
					name: '上传盖章文件',
					value: 1
				// }, {
				// 	name: '在线盖章文件',
				// 	value: 2
				}]
			}
		},
		
		computed: {
			...mapState(['userInfo']),
			...mapGetters(['insuranceState']),
			
			currentProject() {
				return this.projectList.find(item => item.value == this.currentProjectId);
			},
			
			currentInsurance() {
				return this.insuranceType.find(item => item.value == this.currentInsuranceId);
			},
			
			premiumTips() {
				if (this.currentInsurance) {
					let min = this.premiumLadder ? this.premiumLadder.bf_money : this.currentInsurance.data.min_money;
					
					if (this.premiumLadder && this.premiumLadder.end_money) {
						return `保额在${this.premiumLadder.start_money || 0}到${this.premiumLadder.end_money}之间，保费${min}元/年`;
					}
					
					let rate = this.currentInsurance.data.bf_rate * 100;
					return `费率${rate}%，最低保费${min}元/年`;
				}
				return '请选择保函类型';
			},
			
			premiumLadder() {
				if (this.currentInsurance && this.currentInsurance.data.money_json) {
					return JSON.parse(this.currentInsurance.data.money_json).find((item, index) => {
						return !item.end_money || item.end_money >= (parseFloat(this.insuranceSum) || 0);
					});
				}
				return false;
			},
			
			premium() {
				if (this.currentInsurance && this.currentTerm && this.insuranceSum) {
					let year = Math.ceil(this.currentTerm / 12);
					let min = year * (this.premiumLadder ? this.premiumLadder.bf_money : this.currentInsurance.data.min_money);
					
					if (this.premiumLadder && this.premiumLadder.end_money) {
						return min;
					}
					
					let term = parseInt(this.currentTerm) < 12 ? 12 : parseInt(this.currentTerm);
					let sum = (parseFloat(this.insuranceSum) * this.currentInsurance.data.bf_rate / 12 * term).toFixed(0);
					return sum < min ? min : sum;
				}
				return '';
			}
		},
		
		watch: {
			currentProjectId(val) {
				if (val) {
					this.request({
						url: '/project/detail',
						data: {
							project_id: val
						},
						success: data => {
							this.$refs.form.set({
								sshy: data.project_info.sshy,
								sggq: data.project_info.sggq,
								zb_money: data.project_info.zb_money,
								sqr_name: this.id ? undefined : data.project_info.zbqy_user_realname,
								sqr_lxdh: this.id ? undefined : data.project_info.jszg_lxdh,
								yzdw_name: data.project_info.yzdw_name,
								xm_address: data.project_info.xm_address,
								yzdw_address: data.project_info.yzdw_address,
								bbxr_name: this.id ? undefined : data.project_info.bbxr_name,
								bbxr_jgdm: this.id ? undefined : data.project_info.bbxr_jgdm,
								yzdw_lxr: this.id ? undefined : data.project_info.yzdw_lxr,
								yzdw_lxdh: this.id ? undefined : data.project_info.yzdw_lxdh
							});
						}
					});
				}
			},
			
			currentProject() {
				this.validApplyPower();
			},
			
			currentInsurance() {
				this.validApplyPower();
			},
			
			'datumDetail.qs_fdb_type'(val, old) {
				if (old) {
					this.datumDetail.fdb_path = '';
				}
			},
			
			'datumDetail.qs_tbd_type'(val, old) {
				if (old) {
					this.datumDetail.tbd_path = '';
				}
			},
			
			'datumDetail.qs_ywsqs_type'(val, old) {
				if (old) {
					this.datumDetail.ywsqs_path = '';
				}
			},
			
			'datumDetail.qs_zxsqs_type'(val, old) {
				if (old) {
					this.datumDetail.zxsqs_path = '';
				}
			}
		},
		
		mounted() {
			if (!this.datum) {
				for (let i = 1; i < 61; i++) {
					this.termList.push({
						name: i + '个月',
						value: i
					});
				}
				
				this.request({
					url: '/project/select_list',
					data: {
						type: 2
					},
					success: data => {
						this.projectList = Array.from(data, item => {
							return {
								name: item.name,
								value: item.id,
								data: item
							}
						});
					}
				});
				
				if (this.id) {
					this.request({
						url: '/project/bx/detail',
						data: {
							bx_id: this.id
						},
						success: data => {
							this.$refs.form.set({
								bx_id: data.bxInfo.id,
								bxgs_id: data.bxgsInfo.id
							});
							this.getInsuranceCompany(data.bxgsInfo.id);
							this.getInsuranceType(data.bxgsInfo.id);
							this.$refs.form.set(data.bxInfo);
						}
					});
				} else {
					this.$refs.agreement.open();
				}
			} else {
				this.request({
					url: '/project/bx/detail',
					data: {
						bx_id: this.id
					},
					success: data => {
						this.insuranceDetail = data.bxInfo;
						this.templateDetail = data.bxgsTypeInfo || {};
						this.getInsuranceCompany(data.bxgsInfo.id);
						this.datumDetail = {
							bx_id: this.id,
							yyzz_path: data.bxInfo.yyzz_path || this.userInfo.yyzz_path,
							frsfztx_path: data.bxInfo.frsfztx_path || this.userInfo.frsfztx_path,
							frsfzgh_path: data.bxInfo.frsfzgh_path || this.userInfo.frsfzgh_path,
							zzzs_path: data.bxInfo.zzzs_path || this.userInfo.zzzs_path,
							qs_fdb_type: 1,
							fdb_path: data.bxInfo.fdb_path,
							qs_tbd_type: 1,
							tbd_path: data.bxInfo.tbd_path,
							qs_ywsqs_type: 1,
							ywsqs_path: data.bxInfo.ywsqs_path,
							qs_zxsqs_type: 1,
							zxsqs_path: data.bxInfo.zxsqs_path,
							sght_path: data.bxInfo.sght_path,
							cwbb_path: data.bxInfo.cwbb_path
						}
						this.request({
							url: '/project/detail',
							data: {
								project_id: data.bxInfo.project_id
							},
							success: data => {
								this.projectInfo = data.project_info;
							}
						});
					}
				});
			}
		},
		
		methods: {
			initApply() {
				this.$refs.form.set({
					project_id: this.projectId,
					bx_id: this.id,
					bxgs_id: this.companyId,
					bx_type_id: this.type
				});
				this.getInsuranceCompany(this.companyId);
				this.getInsuranceType(this.companyId);
			},
			
			getInsuranceCompany(id) {
				this.request({
					url: '/bxgs/detail',
					data: {
						bxgs_id: id
					},
					success: data => {
						this.insuranceCompany = data;
					}
				});
			},
			
			getInsuranceType(id) {
				this.request({
					url: '/bxgs_type/list',
					data: {
						bxgs_id: id
					},
					success: data => {
						this.insuranceType = Array.from(data, item => {
							return {
								name: item.type_name,
								value: item.type_id,
								data: item
							}
						});
					}
				});
			},
			
			validApplyPower() {
				if (!this._applyPowerTip) {
					this._applyPowerTip = true;
					// if (this.currentInsurance && this.currentInsurance.data.type_id == 3) {
					// 	this.$confirm({
					// 		text: '系统消息提醒',
					// 		message: '农民工保函由于各地费率不一致，请拨打电话：13758112094直接购买',
					// 		buttonName: '我知道了',
					// 		cancelButton: false,
					// 		resolve: () => {
					// 			delete this._applyPowerTip;
					// 			this.$refs.form.set({
					// 				bx_type_id: ''
					// 			});
					// 		}
					// 	});
					// } else {
						delete this._applyPowerTip;
					// }
				}
			},
			
			downloadTemplet(type) {
				this.request({
					url: '/project/bx/template/geturl',
					data: {
						bx_id: this.id,
						template_type: type
					},
					success: data => {
						window.open(data);
					}
				});
			},
			
			signHandle(type) {
				this.request({
					url: '/signature/fr/url',
					data: {
						businessType: type,
						businessId: this.id
					},
					loading: true,
					success: data => {
						window.open(data);
						this.$confirm({
							text: '等待签署中',
							message: '签署完成请点击已完成签署按钮',
							buttonName: '已完成签署',
							resolve: () => {
								this.updateSignFile(type);
							}
						});
					}
				});
			},
			
			updateSignFile(type) {
				this.request({
					url: '/project/bx/detail',
					data: {
						bx_id: this.id
					},
					success: data => {
						if (type == 3 && data.bxInfo.qs_fdb_type == 2 && data.bxInfo.fdb_path) {
							this.datumDetail.fdb_path = data.bxInfo.fdb_path;
						} else if (type == 4 && data.bxInfo.qs_tbd_type == 2 && data.bxInfo.tbd_path) {
							this.datumDetail.tbd_path = data.bxInfo.tbd_path;
						} else if (type == 5 && data.bxInfo.qs_ywsqs_type == 2 && data.bxInfo.ywsqs_path) {
							this.datumDetail.ywsqs_path = data.bxInfo.ywsqs_path;
						} else if (type == 6 && data.bxInfo.qs_zxsqs_type == 2 && data.bxInfo.zxsqs_path) {
							this.datumDetail.zxsqs_path = data.bxInfo.zxsqs_path;
						}
					}
				});
			},
			
			submit() {
				if (!this.datum) {
					this.$refs.form.submit({
						url: this.id ? '/project/bx/updateBase' : '/project/bx/add',
						rule: {
							project_id: '请选择项目',
							bx_type_id: '请选择保函类型',
							bxqx: '请选择保险期限',
							sqr_name: '请填写授权人',
							bd_money: '请填写保单金额',
							bf_money: '请填写保费金额',
							sqr_lxdh: '请填写授权人电话'
						},
						success: (data, id) => {
							this.navigateTo('/transact/insurance/datum', {id});
						}
					});
				} else {
					validate(this.datumDetail, {
						rule: {
							yyzz_path: '请上传营业执照',
							frsfztx_path: '请上传法人身份证头像面',
							frsfzgh_path: '请上传法人身份证国徽面',
							zzzs_path: '请上传资质证书',
							jgysbg_path: [{
								type: 'empty',
								word: '请上传竣工验收报告',
								skip: () => {
									return this.insuranceDetail.bx_type_id != 2;
								}
							}],
							fdb_path: '请上传或签署反担保承诺书',
							tbd_path: '请上传或签署投保单',
							ywsqs_path: [{
								type: 'empty',
								word: '请上传或签署业务申请书',
								skip: () => {
									return this.insuranceCompany.id != 6;
								}
							}],
							zxsqs_path: [{
								type: 'empty',
								word: '请上传或签署征信授权书',
								skip: () => {
									return this.insuranceCompany.id != 6;
								}
							}],
							cwbb_path: '请上传财务报表'
						},
						success: () => {
							this.request({
								url: '/project/bx/updateZlfj',
								data: this.datumDetail,
								loading: true,
								success: () => {
									this.$message({
										text: '提交成功'
									});
									this.navigateTo('/transact/insurance');
								}
							});
						}
					});
				}
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.agreement {
		padding: 10px 32px 32px;
		
		>>> h5 {
			margin: 20px 0 14px;
			line-height: 30px;
			font-size: 18px;
			
			elder({
				line-height: 44px,
				font-size: 28px
			})
		}
		
		>>> p {
			line-height: 24px;
			font-size: 14px;
			text-indent: 2em;
			color: #000;
			
			elder({
				line-height: 38px,
				font-size: 24px
			})
		}
	}
	
	.detail-info {
		padding: 30px 140px 30px 48px;
		background: #F6FBFF;
		
		img {
			height: 50px;
			margin-bottom: 20px;
			
			elder({
				height: 80px
			})
		}
		
		p {
			max-width: 400px;
			padding: 5px 0;
			line-height: 20px;
			font-size: 14px;
			color: #000;
			
			elder({
				line-height: 34px,
				font-size: 24px
			})
			
			label {
				min-width: 6em;
				text-align: right;
				color: #666;
			}
		}
	}
</style>
